(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  const bindTonziWelcome = () => {
    document.querySelectorAll('.tonzi-welcome__form').forEach((form) => {
      if (form.dataset.tonziBound || !form.querySelector('[name="tonzi_professional"]')) return;
      form.dataset.tonziBound = 'true';
      const tags = form.querySelector('[name="contact[tags]"]');
      const updateTags = () => {
        const selected = form.querySelector('[name="tonzi_professional"]:checked');
        tags.value = 'newsletter, whatsapp-popup' + (selected ? ', ' + (selected.value === 'sim' ? 'profissional-da-area' : 'consumidor-final') : '');
      };
      form.addEventListener('change', updateTags);
      const completed = new Set();
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (form.dataset.sending === 'true' || !form.reportValidity()) return;
        updateTags();
        const button = form.querySelector('[type="submit"]');
        const error = form.querySelector('.tonzi-welcome__error');
        const originalText = button.textContent;
        const profile = form.querySelector('[name="tonzi_professional"]:checked').value;
        const contact = {
          name: form.querySelector('[data-rptn-field="name"]').value.trim(),
          email: form.querySelector('[data-rptn-field="email"]').value.trim(),
          phone: form.querySelector('[data-rptn-field="phone"]')?.value.trim() || null
        };
        form.dataset.sending = 'true';
        button.disabled = true;
        button.textContent = button.dataset.loadingText;
        error.hidden = true;
        try {
          for (const id of [profile === 'sim' ? '96075' : '96076', '63973']) {
            const payload = JSON.stringify({id, ...contact});
            if (completed.has(payload)) continue;
            const bytes = new TextEncoder().encode(payload);
            const body = btoa(Array.from(bytes, (byte) => String.fromCharCode(byte)).join('')).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
            const response = await fetch('https://app.reportana.com/events?shop_id=24880', {
              method: 'POST', headers: {'Content-Type': 'text/plain'}, body,
              signal: AbortSignal.timeout(15000)
            });
            if (!response.ok) throw new Error('capture-failed');
            completed.add(payload);
          }
          if (typeof form.submit === 'function') form.submit();
          else HTMLFormElement.prototype.submit.call(form);
        } catch (failure) {
          error.hidden = false;
          button.disabled = false;
          button.textContent = originalText;
          form.dataset.sending = 'false';
        }
      }, true);
    });
  };
  bindTonziWelcome();
  document.addEventListener('shopify:section:load', bindTonziWelcome);

  } catch(e) { console.error(e); }
})();
})();
